import styled, { keyframes } from 'styled-components';
var fadeIn = keyframes(["from{opacity:0;}to{opacity:1;}"]);
export var Wrapper = styled.div.withConfig({
  displayName: "WaveformCanvasstyles__Wrapper",
  componentId: "sc-1va6i12-0"
})(["height:inherit;grid-area:waveform;width:100%;max-width:100%;overflow:hidden;animation:", " 0.45s cubic-bezier(0.4,0,0.2,1);"], fadeIn);